import type { FC } from 'react';

import ExoticsModelBandContent from './exotics-model-band-content';
import type { ExoticsModelBandProps } from './types';

const ExoticsModelBandWidget: FC<ExoticsModelBandProps> = ({ instrumentId }) => (
  <ExoticsModelBandContent instrumentId={instrumentId} />
);

export default ExoticsModelBandWidget;
